const sdk = {};
const _ = {
    cookie: {
        get (name) {
            const nameEQ = `${name}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return decodeURIComponent(c.substring(nameEQ.length, c.length));
                }
            }
            return null;
        },
        set (name, value, days) {
            let expires = '';
            days = days === null ? 73000 : days;

            if (days !== 0) {
                const date = new Date();
                if (String(days).slice(-1) === 's') {
                    date.setTime(date.getTime() + (Number(String(days).slice(0, -1)) * 1000));
                } else {
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                }

                expires = `; expires=${date.toGMTString()}`;
            }

            document.cookie = `${name}=${encodeURIComponent(value)}${expires
            }; path=/`;
        },

        remove (name) {
            _.cookie.set(name, '', -1);
        },

        getCookieName (namePrefix) {
            const sub = `root_${namePrefix}`;
            return sub;
        }
    },
    localStorage: {
        get (name) {
            return window.localStorage.getItem(name);
        },

        parse (name) {
            let storedValue;
            try {
                storedValue = JSON.parse(_.localStorage.get(name)) || null;
            } catch (err) {
                //
            }
            return storedValue;
        },

        set (name, value) {
            window.localStorage.setItem(name, value);
        },

        remove (name) {
            window.localStorage.removeItem(name);
        }
    },
    isObject (obj) {
        return (Object.prototype.toString.call(obj) === '[object Object]') && (obj !== null);
    },
    isEmptyObject (obj) {
        if (_.isObject(obj)) {
            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    return false;
                }
            }
            return true;
        }
        return false;
    },
    isUndefined (obj) {
        return obj === void 0 || obj === undefined || obj === null || obj === '';
    },
    isJSONString: function (str) {
        try {
            JSON.parse(str);
        } catch (err) {
            return false;
        }
        return true;
    },
    each (obj, iterator, context) {
        if (obj === null) {
            return false;
        }
        if ([].forEach && obj.forEach === [].forEach) {
            obj.forEach(iterator, context);
        } else if (obj.length === +obj.length) {
            for (let i = 0, l = obj.length; i < l; i++) {
                if (i in obj && iterator.call(context, obj[i], i, obj) === null) {
                    return false;
                }
            }
        } else {
            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    if (iterator.call(context, obj[key], key, obj) === null) {
                        return false;
                    }
                }
            }
        }
    },
    xhr (cors) {
        if (cors) {
            const xhr = new XMLHttpRequest();
            if ('withCredentials' in xhr) {
                return xhr;
            } else if (typeof XDomainRequest !== 'undefined') {
                return new XDomainRequest(); //eslint-disable-line
            }
            return xhr;
    
        }
        if (XMLHttpRequest) {
            return new XMLHttpRequest();
        }
        if (window.ActiveXObject) {
            try {
                return new ActiveXObject('Msxml2.XMLHTTP'); //eslint-disable-line
            } catch (e) {
                try {
                    return new ActiveXObject('Microsoft.XMLHTTP'); //eslint-disable-line
                } catch (err) {
                    //
                }
            }
        }
    },
    ajax (param) {
        param.credentials = (typeof param.credentials) === 'undefined' ? true : param.credentials;
        const getJSON = function (data) {
            if (!data){
                return '';
            }
            try {
                return JSON.parse(data);
            } catch (e) {
                return {};
            }
        };
        const xhr = _.xhr(param.cors);
        if (!param.type) {
            param.type = param.data ? 'POST' : 'GET';
        }
        param = _.extend({
            success: () => {},
            error: () => {}
        }, param);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
                    param.success(getJSON(xhr.responseText));
                } else {
                    param.error(getJSON(xhr.responseText), xhr.status);
                }
                xhr.onreadystatechange = null;
                xhr.onload = null;
            }
        };
        xhr.open(param.type, param.url, true);
        try {
            if (param.credentials){
                xhr.withCredentials = true;
            }
            if (_.isObject(param.header)) {
                for (const i in param.header) {
                    xhr.setRequestHeader(i, param.header[i]);
                }
            }
            if (param.data) {
                if (!param.cors){
                    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                }
                if (param.contentType === 'application/json') {
                    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
                } else {
                    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                }
            }
        } catch (e) {
            //
        }
        xhr.send(param.data || null);
    },
    hashCode (str) {
        if (typeof str !== 'string'){
            return 0;
        }
        let hash = 0;
        let char = null;
        if (str.length === 0) {
            return hash;
        }
        for (let i = 0; i < str.length; i++) {
            char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
        }
        return hash;
    },
    utf8Encode (string) {
        string = (`${string}`).replace(/\r\n/g, '\n').replace(/\r/g, '\n');

        let utftext = ''; let start; let end;
        let stringl = 0; let n;

        start = end = 0;
        stringl = string.length;

        for (n = 0; n < stringl; n++) {
            const c1 = string.charCodeAt(n);
            let enc = null;

            if (c1 < 128) {
                end++;
            } else if ((c1 > 127) && (c1 < 2048)) {
                enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
            } else {
                enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
            }
            if (enc !== null) {
                if (end > start) {
                    utftext += string.substring(start, end);
                }
                utftext += enc;
                start = end = n + 1;
            }
        }

        if (end > start) {
            utftext += string.substring(start, string.length);
        }

        return utftext;
    },
    base64Encode (data) {
        const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let o1; let o2; let o3; let h1; let h2; let h3; let h4; let bits; let i = 0; let ac = 0; let enc = '';
        const tmpArr = [];
        if (!data) {
            return data;
        }
        data = _.utf8Encode(data);
        do {
            o1 = data.charCodeAt(i++);
            o2 = data.charCodeAt(i++);
            o3 = data.charCodeAt(i++);

            bits = o1 << 16 | o2 << 8 | o3; //eslint-disable-line

            h1 = bits >> 18 & 0x3f;//eslint-disable-line
            h2 = bits >> 12 & 0x3f;//eslint-disable-line
            h3 = bits >> 6 & 0x3f;//eslint-disable-line
            h4 = bits & 0x3f;
            tmpArr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
        } while (i < data.length);

        enc = tmpArr.join('');

        switch (data.length % 3) {
        case 1:
            enc = `${enc.slice(0, -2)}==`;
            break;
        case 2:
            enc = `${enc.slice(0, -1)}=`;
            break;
        }

        return enc;
    },
    getData (data){
        const strData = JSON.stringify(data);
        const base64Data = _.base64Encode(strData);
        return `data=${encodeURIComponent(base64Data)}`;
    },
    addEvent () {
        const fixEvent = event => {
            if (event) {
                event.preventDefault = fixEvent.preventDefault;
                event.stopPropagation = fixEvent.stopPropagation;
                event._getPath = fixEvent._getPath;
            }
            return event;
        };
        fixEvent._getPath = () => {
            const ev = this;
            const polyfill = () => {
                try {
                    let element = ev.target;
                    const pathArr = [element];
                    if (element === null || element.parentElement === null) {
                        return [];
                    }
                    while (element.parentElement !== null) {
                        element = element.parentElement;
                        pathArr.unshift(element);
                    }
                    return pathArr;
                } catch (err){
                    return [];
                }

            };
            return this.path || (this.composedPath && this.composedPath()) || polyfill();
        };
        fixEvent.preventDefault = function () {
            this.returnValue = false;
        };
        fixEvent.stopPropagation = function () {
            this.cancelBubble = true;
        };
        
        const makeHandler = (element, newHandler, oldHandlers) => {
            const handler = function (event) {
                event = event || fixEvent(window.event);
                if (!event) {
                    return undefined;
                }
                event.target = event.srcElement;

                let ret = true;
                let oldResult;
                if (typeof oldHandlers === 'function') {
                    oldResult = oldHandlers(event);
                }
                const newResult = newHandler.call(element, event);
                if ((oldResult === false) || (newResult === false)) {
                    ret = false;
                }
                return ret;
            };
            return handler;
        };

        const registerEvent = function (element, type, handler) {
            if (element && element.addEventListener) {
                element.addEventListener(type, function (e){
                    e._getPath = fixEvent._getPath;
                    handler.call(this, e); //eslint-disable-line
                }, false);
            } else {
                const ontype = `on${type}`;
                const oldHandler = element[ontype];
                element[ontype] = makeHandler(element, handler, oldHandler);
            }
        };

        registerEvent.apply(null, arguments);
    },
    extend (obj) {
        _.each([].slice.call(arguments), source => {
            for (const prop in source) {
                if (source[prop] !== undefined) {
                    if (_.isObject(source[prop]) && _.isObject(obj[prop])) {
                        _.extend(obj[prop], source[prop]);
                    } else if (_.isUndefined(source[prop])) {
                        delete obj[prop];
                    } else {
                        obj[prop] = source[prop];
                    }
                }
            }
        });
        return obj;
    },
    detector (ua) {
        // userAgent regexp
        const expUseragent = {
            // browser
            MSIE: /(msie) ([\w.]+)/,
            MOZILLA: /(mozilla)(?:.*? rv:([\w.]+)|)/,
            SAFARI: /(safari)(?:.*version|)[/]([\d.]+)/,
            CHROME: /(chrome|crios)[/]([\w.]+)/,
            OPERA: /(opera|opr)(?:.*version|)[/]([\w.]+)/,
            WEBOS: /(webos|hpwos)[\s/]([\d.]+)/,
            DOLFIN: /(dolfin)(?:.*version|)[/]([\w.]+)/,
            SILK: /(silk)(?:.*version|)[/]([\w.]+)/,
            UC: /(uc)browser(?:.*version|)[/]([\w.]+)/,
            TAOBAO: /(tao|taobao)browser(?:.*version|)[/]([\w.]+)/,
            LIEBAO: /(lb)browser(?:.*? rv:([\w.]+)|)/,
            MicroMessenger: /micromessenger/i,

            // engine
            WEBKIT: /webkit[/]([\w.]+)/,
            GECKO: /gecko[/]([\w.]+)/,
            PRESTO: /presto[/]([\w.]+)/,
            TRIDENT: /trident[/]([\w.]+)/,
            
            // platform
            MAC: /(mac os x)\s+([\w_]+)/,
            WINNDOWS: /(windows nt)\s+([\w.]+)/,
            LINUX: /linux/,
            IOS: /(i(?:pad|phone|pod))(?:.*)cpu(?: i(?:pad|phone|pod))? os (\d+(?:[.|_]\d+){1,})/,
            ANDROID: /(android)\s+([\d.]+)/,
            IPAD: /(ipad).*os\s([\d_]+)/,
            IPHONE: /(iphone\sos)\s([\d_]+)/,
            IPOD: /(ipod)(?:.*)cpu(?: iphone)? os (\d+(?:[.|_]\d+){1,})/,
            TOUCHPAD: /touchpad/,
            BLACKBERRY: /(playbook|blackberry|bb\d+).*version\/([\d.]+)/,
            RIMTABLET: /rimtablet/,
            BADA: /bada/,
            CHROMEOS: /cromeos/
        };
        const os = {};
        // browser
        
        const chrome = ua.match(expUseragent.CHROME);
        const opera = ua.match(expUseragent.OPERA);
        const msie = ua.match(expUseragent.MSIE);
        const safari = (ua + ua.replace(expUseragent.SAFARI, ' ')).match(expUseragent.SAFARI);

        const mozilla = ua.match(expUseragent.MOZILLA);
        const webos = ua.match(expUseragent.WEBOS);
        const dolphi = ua.match(expUseragent.DOLFIN);
        const silk = ua.match(expUseragent.SILK);
        const uc = ua.match(expUseragent.UC);
        const taobao = ua.match(expUseragent.TAOBAO);
        const liebao = ua.match(expUseragent.LIEBAO);
        // engine
        
        const webkit = ua.match(expUseragent.WEBKIT);
        const gecko = ua.match(expUseragent.GECKO);
        const presto = ua.match(expUseragent.PRESTO);
        const trident = ua.match(expUseragent.TRIDENT);
        // platform
        
        const mac = ua.match(expUseragent.MAC);
        const windows = ua.match(expUseragent.WINNDOWS);
        const linux = ua.match(expUseragent.LINUX);
        const chromeos = ua.match(expUseragent.CHROMEOS);
        // pad
        
        const ipad = ua.match(expUseragent.IPAD);
        const rimtablet = ua.match(expUseragent.RIMTABLET);
        const touchpad = webos && ua.match(expUseragent.TOUCHPAD);
        // mobile
        
        const ipod = ua.match(expUseragent.IPOD);
        const iphone = !ipad && ua.match(expUseragent.IPHONE);
        const android = ua.match(expUseragent.ANDROID);
        const blackberry = ua.match(expUseragent.BLACKBERRY);
        const bada = ua.match(expUseragent.BADA);
        
        // engine
        if (webkit) {
            os.webkit = true;
        }
        if (gecko) {
            os.gecko = true;
        }
        if (presto) {
            os.presto = true;
        }
        if (trident) {
            os.trident = true;
        }
        // platform
        os.platform = {};
        //
        if (mac) {
            os.mac = true;
            os.platform.name = 'mac os';
            os.version = mac[2];
        }
        if (windows) {
            os.windows = true;
            os.platform.name = 'window';
            os.version = windows[2];
        }
        if (linux) {
            os.linux = true;
            os.platform.name = 'linux';
        } //
        if (chromeos) {
            os.chromeos = true;
            os.platform.name = 'chromeos';
            os.version = chromeos[2];
        }
        // if (ios) os.ios=true;//
        if (android) {
            os.android = true;
            os.platform.name = 'android';
            os.version = android[2];
        }
        if (iphone) {
            os.ios = true;
            os.platform.name = 'iphone';
            os.version = iphone[2].replace(/_/g, '.');
            os.iphone = true;
        }
        if (ipod) {
            os.ios = true;
            os.platform.name = 'ipod';
            os.version = ipod[2].replace(/_/g, '.');
            os.ipod = true;
        }
        if (ipad) {
            os.ios = true;
            os.platform.name = 'ipad';
            os.version = ipad[2].replace(/_/g, '.');
            os.ipad = true;
        }
        if (webos) {
            os.webos = true;
            os.platform.name = 'webos';
            os.version = webos[2];
        }
        if (blackberry) {
            os.blackberry = true;
            os.platform.name = 'blackberry';
            os.version = blackberry[2];
        }
        if (bada) {
            os.bada = true;
            os.platform.name = 'bada';
            os.version = '';
        }
        if (rimtablet) {
            os.rimtablet = true;
            os.platform.name = 'rimtablet';
            os.version = '';
        }
        if (touchpad) {
            os.touchpad = true;
            os.platform.name = 'touchpad';
            os.version = '';
        }
        // os.platform.version
        os.platform.version = os.version;
        if (!(android || iphone || ipad || ipod || webos || blackberry || bada || rimtablet || touchpad)) {
            os.desktop = true;
            os.version = '';
        }
        os.browser = {};
        // browser
        /* eslint max-len: ["error", { "code": 180 }]*/
        const match = dolphi || silk || uc || msie || taobao || liebao || opera || chrome || safari || (ua.indexOf('compatible') < 0 && mozilla);
        // chrome
        match[1] = match[1] === 'crios' ? 'chrome' : match[1];
        // taobao
        match[1] = match[1] === 'tao' ? 'taobao' : match[1];
        //
        os[match[1]] = true;
        os.browser.name = match[1];
        os.browser.version = match[2] || '';
        // major
        os.browser.version && (os.major = parseInt(os.browser.version, 10));
        // revise
        // safari
        if (os.ios && os.webkit && !os.desktop) {
            try {
                // in node js
                os.safari = !!((window.canSetSearchEngine || window.TrackEvent));
            } catch (e){
                //
            }
            const v = os.major || parseInt(os['platform-version'], 10) || '';
            v && (os[`ios${v}`] = true);
        }
        // ie 11
        if (os.trident && os.major >= 11){
            os.browser.name = 'msie';
            os.msie = true;
            delete os.mozilla;
        }
        // mozilla/firefox
        if (os.mozilla) {
            os.firefox = true;
        }
        // opera
        if (os.browser.name === 'opr'){
            os.browser.name = 'opera';
            os.opera = os.opr;
        }
        // blackberry
        if (os.blackberry){
            //
            delete os.safari;
        }
        // MicroMessager
        if (expUseragent.MicroMessenger.test(ua)){
            os.micromessage = true;
        }
        // uc
        const DOMWindow = DOMWindow || {}; //eslint-disable-line 
        if (DOMWindow && DOMWindow.UCNewsJSController) {
            os.uc = true;
            os.browser.name = 'uc';
        }
        //
        try {
            // orientation
            os.orientation = (window.orientation === 180 || window.orientation === 0) ? 'portrait' : 'landscape';
        } catch (e){
            //
        }
        // os.platform.type
        if (os.desktop){
            os.platform.type = 'PC';
        } else {
            os.platform.type = 'mobile';
        }
        //
        return os;
    },
    getCurrentDate () {
        if (arguments[0]) {
            return +new Date();
        }
        return new Date();
    },
    getEnvironments () {
        if (window.location.hostname.includes('testing')) {
            return 'testing';
        }
        return 'production';
    },
    getPlatform () {
        const WEB = 'WEB';
        const APP = 'APP';
        if (window.app) {
            return APP;
        }
        return WEB;
    }
};
const generUUID = (function () {
    const T = function () {
        const d = 1 * new Date(); let i = 0;
        while (d === 1 * new Date()) {
            i++;
        }
        return d.toString(16) + i.toString(16);
    };
    const R = function () {
        return Math.random().toString(16)
            .replace('.', '');
    };
    const UA = function () {
        const ua = navigator.userAgent; let i; let ch; let buffer = []; let ret = 0;

        const xor = function (result, byteArray) {
            let j; let tmp = 0;
            for (j = 0; j < byteArray.length; j++) {
                tmp |= (buffer[j] << j * 8);
            }
            return result ^ tmp;
        };

        for (i = 0; i < ua.length; i++) {
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }

        if (buffer.length > 0) {
            ret = xor(ret, buffer);
        }

        return ret.toString(16);
    };

    return function () {
        // 有些浏览器取个屏幕宽度都异常...
        let se = String(screen.height * screen.width);
        if (se && /\d{5,}/.test(se)) {
            se = se.toString(16);
        } else {
            se = String(Math.random() * 31242).replace('.', '')
                .slice(0, 8);
        }
        const val = (`${T()}-${R()}-${UA()}-${se}-${T()}`);
        if (val){
            return val;
        }
        return (String(Math.random()) + String(Math.random()) + String(Math.random())).slice(2, 15);
        
    };
}());
const store = {
    _sessionState: {},
    _state: {},
    getProps: function () {
        return this._state.props || {};
    },
    getSessionProps: function () {
        return this._sessionState;
    },
    getDistinctId: function () {
        return this._state.distinct_id;
    },
    getFirstId: function (){
        return this._state.first_id;
    },
    toState: function (ds) {
        let state = null;
        if (ds !== null && _.isJSONString(ds)) {
            state = JSON.parse(ds);
            this._state = _.extend(state);
            if (state.distinct_id) {
                if (typeof (state.props) === 'object'){
                    for (const key in state.props){
                        if (typeof state.props[key] === 'string'){
                            state.props[key] = state.props[key].slice(0, 200);
                        }
                    }
                    this.save();
                }
            } else {
                this.set('distinct_id', generUUID());
            }
        } else {
            this.set('distinct_id', generUUID());
        }
    },
    initSessionState: function () {
        const ds = _.cookie.get('ht_session');
        let state = null;
        if (ds !== null && (typeof (state = JSON.parse(ds)) === 'object')) {
            this._sessionState = state || {};
        }
    },
    setOnce: function (a, b) {
        if (!(a in this._state)) {
            this.set(a, b);
        }
    },
    set: function (name, value) {
        this._state = this._state || {};
        this._state[name] = value;
        this.save();
    },
    change: function (name, value) {
        this._state[name] = value;
    },
    setSessionProps: function (newp) {
        const props = this._sessionState;
        _.extend(props, newp);
        this.sessionSave(props);
    },
    setSessionPropsOnce: function (newp) {
        const props = this._sessionState;
        _.coverExtend(props, newp);
        this.sessionSave(props);
    },
    setProps: function (newp, isCover) {
        const props = this._state.props || {};
        if (isCover){
            this.set('props', newp);
        } else {
            _.extend(props, newp);
            this.set('props', props);
        }
    },
    removeProps: function (newp){
        if (!_.isArray(newp)){
            return false;
        }
        const props = this._state.props || {};
        for (let i = 0; i < newp.length; i++){
            if (newp[i] in props){
                delete props[i];
            }
        }
        this.set('props', props);
    },
    setPropsOnce: function (newp) {
        const props = this._state.props || {};
        _.coverExtend(props, newp);
        this.set('props', props);
    },
    clearAllProps: function () {
        this._sessionState = {};
        for (const i in this._state.props){
            if (i.indexOf('latest_') !== 1){
                delete this._state.props[i];
            }
        }
        this.sessionSave({});
        this.save();
    },
    sessionSave: function (props) {
        this._sessionState = props;
        _.cookie.set('ht_session', JSON.stringify(this._sessionState), 0);
    },
    save: function () {
        _.cookie.set(this.getCookieName(), JSON.stringify(this._state), 73000);
    },
    getCookieName: function (){
        const sub = 'ht_jssdk';
        return sub;
    },
    init: function () {
        this.initSessionState();
        const uuid = generUUID();
        const cross = _.cookie.get(this.getCookieName());
        if (cross === null) {
            this.set('distinct_id', uuid);
        } else {
            this.toState(cross);
        }
    }
};
const _trackLink = (obj, eventName, eventProp) => {
    obj = obj || {};
    let link = null;
    if (obj.ele){
        link = obj.ele;
    }
    if (obj.event){
        if (obj.target){
            link = obj.target;
        } else {
            link = obj.event.target;
        }
    }

    eventProp = eventProp || {};
    if (!link || (typeof link !== 'object')){
        return false;
    }
    // 如果是非当前页面会跳转的链接，直接track
    if (!link.href || /^javascript/.test(link.href) || link.target || link.download || link.onclick) {
        sdk.track(eventName, eventProp);
        return false;
    }
    const linkFunc = e => {
        e.stopPropagation();
        e.preventDefault(); // 阻止默认跳转
        let hasCalled = false;
        const trackAClick = () => {
            if (!hasCalled) {
                hasCalled = true;
                location.href = link.href; // 把 A 链接的点击跳转,改成 location 的方式跳转
            }
        };
        setTimeout(trackAClick, 1000); // 如果没有回调成功，设置超时回调
        sdk.track(eventName, eventProp, trackAClick); // 把跳转操作加在callback里
    };
    if (obj.event){
        linkFunc(obj.event);
    }
    if (obj.ele){
        _.addEvent(obj.ele, 'click', e => {
            linkFunc(e);
        });
    }
};
const UA = _.detector(navigator.userAgent.toLowerCase());
store.init();
sdk.paramBasic = {
    basic: {
        stack: 'frontend',
        env: _.getEnvironments(),
        project: {
            project: '',
            version: '',
            experimentId: '0'
        },
        product: 'coding',
        user: {
            userId: store.getDistinctId()
        },
        eventTime: _.getCurrentDate().getTime(),
        eventId: generUUID(),
        event: '',
        browser: {
            browser: UA.browser.name,
            version: UA.browser.version
        },
        device: {
            deviceId: store.getDistinctId()
        },
        platform: {
            platform: 'web',
            os: UA.platform.name,
            version: UA.platform.version
        }
    }
};
sdk.param = {
    basic: {}
};
sdk.paramData = {
    data: {}
};
sdk.initParam = param => {
    // 默认配置
    sdk.param.basic = param || {};
    let i;
    // 合并配置
    for (i in sdk.paramBasic.basic) {
        if (!sdk.param.basic[i]) {
            sdk.param.basic[i] = sdk.paramBasic.basic[i];
        }
    }
};

const getHost = () => {
    if (window.location.hostname.includes('testing')) {
        return 'kfk.testing.pipacoding.com';
    }
    return 'datacenter.hetao101.com';
};
const serverUrl = `//${getHost()}/eventdatatransfer/v1/track`;
const dataSend = data => _.ajax({
    url: `${serverUrl}?${_.getData(data)}`,
    type: 'get',
    credentials: false,
    cors: true
});

sdk.track = (e, p) => {
    sdk.param.basic.event = e;
    sdk.param.basic.eventId = generUUID();
    sdk.paramData.data = {};
    Object.assign(sdk.paramData.data, _.extend(p));
    dataSend(Object.assign(sdk.param, sdk.paramData));
};

sdk.trackLink = (elem, e, p) => {
    sdk.param.basic.event = e;
    sdk.param.basic.eventId = generUUID();
    sdk.paramData.data = {};
    Object.assign(sdk.paramData.data, _.extend(p));
    if (typeof elem === 'object' && elem.tagName){
        _trackLink({ele: elem}, e, Object.assign(sdk.param, sdk.paramData));
    } else if (typeof elem === 'object' && elem.target && elem.event){
        _trackLink(elem, e, Object.assign(sdk.param, sdk.paramData));
    }
};

sdk.login = function (id){
    if (typeof id === 'number'){
        id = String(id);
    }
    try {
        const firstId = store.getFirstId();
        const distinctId = store.getDistinctId();
        if (id !== distinctId){
            if (firstId){
                store.set('distinct_id', id);
            } else {
                store.set('first_id', distinctId);
            }
        }
    } catch (e) {
        // console.log('login的参数必须是字符串');
    }
};

sdk.init = param => {
    sdk.initParam(param);
};

window.ht = sdk;
